<template>
    <div>
        <div class="content-caption dashed">
            <span>合同信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>系统合同编号</label>
                </div>
                <div class="form-value">
                    <span>{{contract.no}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>合同名称</label>
                </div>
                <div class="form-value">
                    <span>{{contract.title}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>卖家公司名称</label>
                </div>
                <div class="form-value">
                    <span>{{contract.sndPartyRealComName}}</span>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>付款阶段</span>
        </div>
        <div class="simple-form label">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">付款账期形式</label>
                </div>
                <div class="form-value width-3x">
                    <el-radio-group v-model="contract.acntPeriodForm" @change="acntPeriodFormChange">
                        <el-radio :label="2" v-if="payPeriodTypesAllowed.indexOf(2) > -1"><span>阶段间隔天数</span></el-radio>
                        <el-radio :label="1" v-if="payPeriodTypesAllowed.indexOf(1) > -1"><span>账期</span></el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <el-form :model="contract" ref="contractPhasedPaySettingList">
            <table class="custom-tbl error-prompt">
                <thead class="head">
                <tr class="row">
                    <th class="text-align: left; required">阶段名称</th>
                    <th width="200" class="text-align: left; required">阶段类型</th>
                    <th width="200" class="text-align: right; required">账期起算规则</th>
                    <th width="100" class="text-align: right; required" v-if="contract.acntPeriodForm == 1">账期(天)</th>
                    <th width="140" class="text-align: right; required" v-if="contract.acntPeriodForm == 2">当期阶段间隔天数</th>
                    <th width="200" class="text-align: left; required">金额计算依据</th>
                    <th width="120" class="text-align: left; required">付款比例(%)</th>
                    <th width="150" class="text-align: right; required">支付方式</th>
                    <th width="100">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr v-for="(item,index) in contract.contractPhasedPaySettingList" class="row">
                    <td :rowspan="item.rowspanNum" v-if="item.showPhaseNameAndPhaseType">
                        <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.phaseName'" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input class="fl" style="width: 80%;" type="text" v-model="item.phaseName" @blur="phaseNameChange(index)"></el-input>
                            <a class="swb-btn-link fr inline-block" @click="addPaySetting(item, index)" v-if="item.rowspanNum < payMethodList.length">增加付款次数</a>
                        </el-form-item>
                    </td>
                    <td :rowspan="item.rowspanNum" v-if="item.showPhaseNameAndPhaseType">
                        <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.phaseType'" :rules="{validator: checkNull, trigger: 'change'}">
                            <el-select v-model="item.phaseType" @change="phaseTypeChange(index)">
                                <el-option v-for="item in phaseTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td :rowspan="item.rowspanNum" v-if="item.showPhaseNameAndPhaseType"><!-- 账期起算规则 acntPeriodBasis -->
                        <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.acntPeriodBasis'" :rules="{validator: checkNull, trigger: 'change'}">
                            <el-select v-model="item.acntPeriodBasis" @change="acntPeriodBasisChange(index)">
                                <el-option v-for="item in acntPeriodStartTPList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td class="text-right" :rowspan="item.rowspanNum" v-if="contract.acntPeriodForm == 1 && item.showPhaseNameAndPhaseType"><!-- 账期(天) acntPeriodDays -->
                        <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.acntPeriodDays'" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input type="number" :min="0" v-model="item.acntPeriodDays" @blur="acntPeriodDaysChange(index)"></el-input>
                        </el-form-item>
                    </td>
                    <td class="text-right" :rowspan="item.rowspanNum" v-if="contract.acntPeriodForm == 2 && item.showPhaseNameAndPhaseType"> <!-- 当期阶段间隔天数 phaseGapDays -->
                        <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.phaseGapDays'" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input type="number" :min="0" v-model.number="item.phaseGapDays" @blur="phaseGapDaysChange(index)"></el-input>
                        </el-form-item>
                    </td>
                    <td><!-- 金额计算依据 calcBasis -->
                        <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.calcBasis'" :rules="{validator: checkNull, trigger: 'change'}">
                            <el-select v-model="item.calcBasis">
                                <el-option v-for="item in amtCalcMethodList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td class="text-right">
                        <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.ratio'" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input v-model="item.ratio" @blur="ratioChange(index)"></el-input>
                        </el-form-item>
                    </td>
                    <td><!-- 支付方式 payMethod -->
                        <el-form-item :prop="'contractPhasedPaySettingList.' + index + '.payMethod'" :rules="{validator: checkNull, trigger: 'change'}">
                            <el-select v-model="item.payMethod" @change="payMethodChange(index)">
                                <el-option v-for="item in payMethodList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <div @click="removeContractPhasedPaySetting(index);" class="swb-btn swb-btn-link">
                            <span>移除</span>
                        </div>
                    </td>
                </tr>
                </tbody>
                <tfoot class="foot">
                <tr class="row">
                    <td colspan="8" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;">
                        <div @click="addContractPhasedPaySetting();" class="swb-btn swb-btn-link">
                            <i class="icon iconfont icon-jiahao mr5"></i>
                            <span>添加阶段</span>
                        </div>
                    </td>
                </tr>
                </tfoot>
            </table>
        </el-form>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    //
    import contractApi from '../../api/contract'

    import SwbGoodsPurchContractList from './GoodsPurchContractList';
    import merchtQualiApi from "../../api/merchtQuali";
    import {getRealCtrlParam} from "../asset/assetMain";
    Routes.add(SwbGoodsPurchContractList);

    export default {
        name: 'swb-contract-phased-pay-setting-modify',
        desc: '合同 - 付款阶段变更',
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                contract: {
                    contractPhasedPaySettingList: []
                },
                dbContract: {},
                phaseTypeList: getEnumList('payPhaseType') || [],
                payPhaseTypeFinalPayment: getEnumInfoWith('payPhaseType', 'name', 'FinalPayment').value,
                amtCalcMethodList: [],
                acntPeriodStartTPList: getEnumList('acntPeriodStartTP') || [],
                payMethodList: getEnumList('payMethod') || [],
                payPeriodTypesAllowed: [1]
            }
        },
        created: function () {
            let self = this;
            // 金额计算依据
            let amtCalcMethodList = [];
            let amtCalcMethods = getEnumList('amtCalcMethod') || [];
            let amtCalcMethodByAmount = getEnumInfoWith('amtCalcMethod', 'name', 'ByAmount');
            for (let i = 0; i < amtCalcMethods.length; i++) {
                let amtCalcMethod = amtCalcMethods[i];
                if (amtCalcMethod.name != amtCalcMethodByAmount.name) {
                    amtCalcMethodList.push(amtCalcMethod);
                }
            }
            this.amtCalcMethodList = Utils.merge([], amtCalcMethodList);
            //
            this.getContract();
        },
        methods: {
            // 获取合同信息
            getContract: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        let contract = result.data;
                        // 付款阶段
                        let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                        if (contractPhasedPaySettingList.length > 0) {
                            let index = null;
                            let phaseName = '';
                            let rowFlag = '';
                            let acntPeriodForm = contract.acntPeriodForm;
                            for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                                let contractPhasedPaySetting = contractPhasedPaySettingList[i];
                                contractPhasedPaySetting.originalPhaseName = contractPhasedPaySetting.phaseName;
                                if (acntPeriodForm == 1) {
                                    // 账期
                                    let acntPeriodDays = contractPhasedPaySetting.acntPeriodDays;
                                    if (parseInt(acntPeriodDays) == 0) {
                                        contractPhasedPaySetting.acntPeriodDays = null;
                                    }
                                } else if (acntPeriodForm == 2) {
                                    // 阶段间隔天数
                                    let phaseGapDays = contractPhasedPaySetting.phaseGapDays;
                                    if (parseInt(phaseGapDays) == 0) {
                                        contractPhasedPaySetting.phaseGapDays = null;
                                    }
                                }
                                if (i == 0) {
                                    contractPhasedPaySetting.rowspanNum = 1;
                                    contractPhasedPaySetting.showPhaseNameAndPhaseType = true;
                                    contractPhasedPaySetting.rowFlag = 'row' + i;
                                    phaseName = contractPhasedPaySetting.phaseName;
                                    rowFlag = contractPhasedPaySetting.rowFlag;
                                    index = i;
                                } else {
                                    if (phaseName == contractPhasedPaySetting.phaseName) {
                                        contractPhasedPaySettingList[index].rowspanNum += 1;
                                        contractPhasedPaySetting.rowspanNum = 1;
                                        contractPhasedPaySetting.showPhaseNameAndPhaseType = false;
                                        contractPhasedPaySetting.rowFlag = rowFlag;
                                    } else {
                                        contractPhasedPaySetting.rowspanNum = 1;
                                        contractPhasedPaySetting.showPhaseNameAndPhaseType = true;
                                        contractPhasedPaySetting.rowFlag = 'row' + i;
                                        phaseName = contractPhasedPaySetting.phaseName;
                                        rowFlag = contractPhasedPaySetting.rowFlag;
                                        index = i;
                                    }
                                }
                            }
                            contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                        }
                        //
                        self.contract = Utils.merge({}, contract);
                        self.dbContract = Utils.merge({}, contract);
                        //
                        getRealCtrlParam('contract.allowed.pay.period.types', function (result) {
                            self.payPeriodTypesAllowed = result;
                            if (self.payPeriodTypesAllowed.indexOf(self.contract.acntPeriodForm) == -1) {
                                self.contract.acntPeriodForm = self.payPeriodTypesAllowed[0];
                            }
                        });
                    }
                });
            },
            // 校验
            checkNull: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    callback();
                }
            },
            // 付款账期形式校验
            acntPeriodFormChange: function () {
                let contract = this.contract || {};
                let acntPeriodForm = contract.acntPeriodForm;
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let contractPhasedPaySetting = contractPhasedPaySettingList[i];
                    if (acntPeriodForm == 1) {
                        // 账期
                        let acntPeriodDays = contractPhasedPaySetting.acntPeriodDays;
                        if (parseInt(acntPeriodDays) == 0) {
                            contractPhasedPaySetting.acntPeriodDays = null;
                        }
                    } else if (acntPeriodForm == 2) {
                        // 阶段间隔天数
                        let phaseGapDays = contractPhasedPaySetting.phaseGapDays;
                        if (parseInt(phaseGapDays) == 0) {
                            contractPhasedPaySetting.phaseGapDays = null;
                        }
                    }
                }
                //
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 阶段名称
            phaseNameChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let phaseName = contractPhasedPaySetting.phaseName;
                let originalPhaseName = contractPhasedPaySetting.originalPhaseName;
                if (!Utils.isNoB(phaseName)) {
                    if (phaseName.length > 30) {
                        MsgBox.warning('阶段名称最多可输入30个字！');
                        contractPhasedPaySetting.phaseName = null;
                    } else {
                        for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                            let phasedPaySetting = contractPhasedPaySettingList[i];
                            let phaseNameX = phasedPaySetting.phaseName;
                            if (i != index && phaseNameX == phaseName && phasedPaySetting.rowFlag != contractPhasedPaySetting.rowFlag && Utils.isTrue(phasedPaySetting.showPhaseNameAndPhaseType)) {
                                MsgBox.warning('已存在相同的阶段名称，请重新输入！');
                                contractPhasedPaySetting.phaseName = null;
                                break;
                            }
                        }
                    }
                    if (Utils.isNoB(contractPhasedPaySetting.id) && !Utils.isNoB(contractPhasedPaySetting.phaseName)) {
                        contractPhasedPaySetting.originalPhaseName = contractPhasedPaySetting.phaseName;
                    } else if (Utils.isNoB(contractPhasedPaySetting.phaseName)) {
                        contractPhasedPaySetting.phaseName = originalPhaseName;
                    }
                    for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                        let phasedPaySetting = contractPhasedPaySettingList[i];
                        if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag && !Utils.isTrue(phasedPaySetting.showPhaseNameAndPhaseType)) {
                            phasedPaySetting.phaseName = contractPhasedPaySetting.phaseName;
                        }
                    }
                    //
                    contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                    this.contract = Utils.merge({}, contract);
                }
            },
            // 阶段类型
            phaseTypeChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let phaseType = contractPhasedPaySetting.phaseType;
                let payPhaseType = getEnumInfoWith('payPhaseType', 'name', 'FinalPayment');
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let phasedPaySetting = contractPhasedPaySettingList[i];
                    if (index < i && phaseType == payPhaseType.value && phasedPaySetting.rowFlag != contractPhasedPaySetting.rowFlag) {
                        MsgBox.warning('阶段类型[尾款]只能设置在最后一行，请重新设置！');
                        contractPhasedPaySetting.phaseType = null;
                        break;
                    }
                    if (i != index && phaseType == payPhaseType.value && phasedPaySetting.phaseType == payPhaseType.value && phasedPaySetting.rowFlag != contractPhasedPaySetting.rowFlag) {
                        MsgBox.warning('已存在阶段类型为[' + payPhaseType.text + ']，请重新选择阶段类型！');
                        contractPhasedPaySetting.phaseType = null;
                        break;
                    }
                    if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag) {
                        phasedPaySetting.phaseType = phaseType;
                    }
                }
                //
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 付款比例
            ratioChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let ratio = contractPhasedPaySetting.ratio;
                if (!Utils.isNoB(ratio)) {
                    if (Utils.isNumStr(ratio)) {
                        if (parseFloat(ratio) <= 0) {
                            MsgBox.warning('付款比例(%)必须是大于0小于等于100的数字！');
                            contractPhasedPaySetting.ratio = null;
                        } else {
                            let ratioVal = 0;
                            for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                                let phasedPaySetting = contractPhasedPaySettingList[i];
                                if (phasedPaySetting.ratio != null) {
                                    phasedPaySetting.ratio = parseFloat(phasedPaySetting.ratio);
                                    ratioVal += parseFloat(phasedPaySetting.ratio);
                                }
                            }
                            if (ratioVal > 100) {
                                MsgBox.warning('付款比例(%)总和不能超过100%！');
                            } else {
                                contractPhasedPaySetting.ratio = parseFloat(ratio);
                            }
                        }
                    } else {
                        MsgBox.warning('付款比例(%)只能是数字！');
                        contractPhasedPaySetting.ratio = null;
                    }
                    //
                    contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                    this.contract = Utils.merge({}, contract);
                }
            },
            acntPeriodBasisChange(index){
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let phasedPaySetting = contractPhasedPaySettingList[i];
                    if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag) {
                        phasedPaySetting.acntPeriodBasis = contractPhasedPaySetting.acntPeriodBasis;
                    }
                }
                //
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 账期
            acntPeriodDaysChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let acntPeriodDays = contractPhasedPaySetting.acntPeriodDays;
                if (!Utils.isNoB(acntPeriodDays)) {
                    if (Utils.isIntStr(acntPeriodDays)) {
                        if (parseInt(acntPeriodDays) <= 0) {
                            MsgBox.warning('账期(天)只能是正整数！');
                            contractPhasedPaySetting.acntPeriodDays = null;
                        } else {
                            contractPhasedPaySetting.acntPeriodDays = acntPeriodDays;
                        }
                    } else {
                        MsgBox.warning('账期(天)只能是正整数！');
                        contractPhasedPaySetting.acntPeriodDays = null;
                    }
                    for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                        let phasedPaySetting = contractPhasedPaySettingList[i];
                        if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag) {
                            phasedPaySetting.acntPeriodDays = contractPhasedPaySetting.acntPeriodDays;
                        }
                    }
                    //
                    contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                    this.contract = Utils.merge({}, contract);
                }
            },
            // 支付方式
            payMethodChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let payMethod = contractPhasedPaySetting.payMethod;
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let phasedPaySetting = contractPhasedPaySettingList[i];
                    if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag && payMethod == phasedPaySetting.payMethod) {
                        MsgBox.warning('同一个阶段不能存在重复的支付方式！');
                        contractPhasedPaySetting.payMethod = null;
                        break;
                    }
                }
                //
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 当期阶段间隔天数
            phaseGapDaysChange: function (index) {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                let phaseGapDays = contractPhasedPaySetting.phaseGapDays;
                if (!Utils.isNoB(phaseGapDays)) {
                    if (Utils.isIntStr(phaseGapDays)) {
                        if (parseInt(phaseGapDays) <= 0) {
                            MsgBox.warning('当期阶段间隔天数只能是正整数！');
                            contractPhasedPaySetting.phaseGapDays = null;
                        } else {
                            contractPhasedPaySetting.phaseGapDays = phaseGapDays;
                        }
                    } else {
                        MsgBox.warning('当期阶段间隔天数只能是正整数！');
                        contractPhasedPaySetting.phaseGapDays = null;
                    }
                    for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                        let phasedPaySetting = contractPhasedPaySettingList[i];
                        if (i != index && phasedPaySetting.rowFlag == contractPhasedPaySetting.rowFlag) {
                            phasedPaySetting.phaseGapDays = contractPhasedPaySetting.phaseGapDays;
                        }
                    }
                    //
                    contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                    this.contract = Utils.merge({}, contract);
                }
            },
            // 添加阶段
            addContractPhasedPaySetting: function () {
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                //
                if(contractPhasedPaySettingList.length > 0) {
                    let lastContractPhasedPaySetting = contractPhasedPaySettingList[contractPhasedPaySettingList.length - 1];
                    if (lastContractPhasedPaySetting.phaseType === this.payPhaseTypeFinalPayment) {
                        MsgBox.warning('阶段类型[尾款]后，不能再添加阶段！');
                        return;
                    }
                }
                //
                let contractPhasedPaySetting = {
                    phaseName: null,
                    phaseType: null, // getEnumInfoWith('payPhaseType', 'name', 'StagePayment').value,
                    calcBasis: getEnumInfoWith('amtCalcMethod', 'name', 'ByPercent').value,
                    ratio: null,
                    acntPeriodBasis: null,
                    acntPeriodDays: null,
                    phaseGapDays: null,
                    payMethod: getEnumInfoWith('payMethod', 'name', 'Transfer').value,
                    rowspanNum: 1, // 合并行数
                    showPhaseNameAndPhaseType: true, // 新增加的行是否展示前两列，单据增加行的时候默认展示
                    rowFlag: 'row' + contractPhasedPaySettingList.length // 行标记，是一组的行标记相同
                };
                //
                contractPhasedPaySettingList.push(contractPhasedPaySetting);
                contract.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contract);
            },
            // 增加付款次数
            addPaySetting: function (row, index) {
                let payMethodList = this.payMethodList || [];
                if (row.rowspanNum == payMethodList.length) {
                    MsgBox.warning('同一个阶段不能存在重复的支付方式！');
                    return;
                }
                let payMethod = row.payMethod;
                let payMethodTransfer = getEnumInfoWith('payMethod', 'name', 'Transfer').value;
                let payMethodAcceptanceBill = getEnumInfoWith('payMethod', 'name', 'AcceptanceBill').value;
                if (Utils.isNoB(payMethod)) {
                    payMethod = payMethodTransfer;
                } else if (payMethod == payMethodTransfer) {
                    payMethod = payMethodAcceptanceBill;
                } else if (payMethod == payMethodAcceptanceBill) {
                    payMethod = payMethodTransfer;
                }
                //
                let contractPhasedPaySetting = {
                    phaseName: row.phaseName,
                    phaseType: row.phaseType,
                    calcBasis: row.calcBasis,
                    ratio: null,
                    acntPeriodBasis: row.acntPeriodBasis,
                    acntPeriodDays: row.acntPeriodDays,
                    phaseGapDays: row.phaseGapDays,
                    payMethod: payMethod,
                    rowspanNum: 1, // 合并行数
                    showPhaseNameAndPhaseType: false, // 新增加的行是否展示前两列，默认不展示
                    rowFlag: row.rowFlag
                };
                //
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                let dataList = [];
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    let item = contractPhasedPaySettingList[i];
                    if (i < index) {
                        dataList[i] = item;
                    } else if (i === index) {
                        item.rowspanNum += 1;
                        dataList[i] = item;
                        dataList[i + 1] = contractPhasedPaySetting;
                    } else if (i > index) {
                        dataList[i + 1] = item;
                    }
                }
                contract.contractPhasedPaySettingList = Utils.merge([], dataList);
                this.contract = Utils.merge({}, contract);
            },
            // 移除付款阶段
            removeContractPhasedPaySetting: function (index) {
                let contractInfo = this.contract || {};
                //
                let contractPhasedPaySettingList = contractInfo.contractPhasedPaySettingList || [];
                let contractPhasedPaySetting = contractPhasedPaySettingList[index];
                if (contractPhasedPaySetting.rowspanNum > 1) {
                    contractPhasedPaySettingList[index + 1].rowspanNum = contractPhasedPaySetting.rowspanNum - 1;
                    contractPhasedPaySettingList[index + 1].showPhaseNameAndPhaseType = true;
                } else {
                    let index_X = null;
                    for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                        let item = contractPhasedPaySettingList[i];
                        if (item.rowFlag == contractPhasedPaySetting.rowFlag && item.rowspanNum > 1) {
                            index_X = i;
                            break;
                        }
                    }
                    if (!Utils.isNoB(index_X)) {
                        contractPhasedPaySettingList[index_X].rowspanNum -= 1;
                    }
                }
                contractPhasedPaySettingList.splice(index, 1);
                // 重新计算rowFlag
                let preRow = null;
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    if (preRow == null) {
                        contractPhasedPaySettingList[i].newRowFlag = 'row' + i;
                        preRow = contractPhasedPaySettingList[i];
                    } else if(preRow.rowFlag == contractPhasedPaySettingList[i].rowFlag){
                        contractPhasedPaySettingList[i].newRowFlag = preRow.newRowFlag;
                    } else {
                        contractPhasedPaySettingList[i].newRowFlag = 'row' + i;
                        preRow = contractPhasedPaySettingList[i];
                    }
                }
                for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                    contractPhasedPaySettingList[i].rowFlag = contractPhasedPaySettingList[i].newRowFlag;
                }
                //
                contractInfo.contractPhasedPaySettingList = Utils.merge([], contractPhasedPaySettingList);
                this.contract = Utils.merge({}, contractInfo);
            },
            // 选择商品
            getDlgResult: function () {
                let self = this;
                let result = {};
                let ratioMsg = '';
                let contract = this.contract || {};
                let contractPhasedPaySettingList = contract.contractPhasedPaySettingList || [];
                if (contractPhasedPaySettingList.length <= 0) {
                    result.type = "warn";
                    result.message = "请设置付款阶段！";
                } else {
                    let payPhaseFlag = true;
                    self.$refs['contractPhasedPaySettingList'].validate(function (valid) {
                        if (valid) {
                            let ratioSum = 0;
                            for (let i = 0; i < contractPhasedPaySettingList.length; i++) {
                                let contractPhasedPaySetting = contractPhasedPaySettingList[i];
                                //
                                if (contract.acntPeriodForm == 2) {
                                    contractPhasedPaySetting.acntPeriodDays = null;
                                } else {
                                    contractPhasedPaySetting.phaseGapDays = null;
                                }
                                contractPhasedPaySetting.seqNo = i;
                                //
                                let ratio = contractPhasedPaySetting.ratio;
                                if (ratio != null && parseFloat(ratio) > 0) {
                                    ratioSum += parseFloat(ratio);
                                } else {
                                    payPhaseFlag = false;
                                }
                            }
                            if (ratioSum > 100) {
                                payPhaseFlag = false;
                                ratioMsg = '付款比例总和不能超过100%！';
                            } else if (ratioSum != 100) {
                                ratioMsg = '当前付款阶段比例不是100%，确认要继续操作吗？';
                            }
                        } else {
                            payPhaseFlag = false;
                        }
                    });
                    if (!payPhaseFlag) {
                        result.type = "warn";
                        if (ratioMsg != '') {
                            result.message = ratioMsg;
                        } else {
                            result.message = '请输入付款阶段相关内容！';
                        }
                    } else {
                        //
                        if (Utils.obj_val_equal(self.dbContract, contract, true, [])) {
                            // 没有变化，无需保存
                            result.type = "warn";
                            result.message = "没有修订任何信息，无需进行此操作！";
                        } else {
                            //
                            result.type = "info";
                            result.data = Utils.merge({}, contract);
                            if (ratioMsg.length > 0) {
                                result.message = ratioMsg;
                            }
                        }
                    }
                }
                //
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractPhasedPaySettingModify.vue